import { render, staticRenderFns } from "./birthInfo.vue?vue&type=template&id=6d7db8f6&scoped=true"
import script from "./birthInfo.vue?vue&type=script&lang=js"
export * from "./birthInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7db8f6",
  null
  
)

export default component.exports